import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { FuseScrollbarModule } from '@fuse/directives/scrollbar';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutModule } from 'app/layout/layouts/empty/empty.module';
import { ClassicLayoutModule } from 'app/layout/layouts/vertical/classic/classic.module';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { CommonModule } from '@angular/common';

const layoutModules = [
  // Empty
  EmptyLayoutModule,

  // Vertical navigation
  ClassicLayoutModule,
];

@NgModule({
  declarations: [LayoutComponent],
  imports: [
    FuseLoadingBarModule,
    MatIconModule,
    FuseDrawerModule,
    FuseScrollbarModule,
    CommonModule,
    ...layoutModules,
  ],
  exports: [LayoutComponent, ...layoutModules],
})
export class LayoutModule {}
